import { render, staticRenderFns } from "./AnswerOptionsA.vue?vue&type=template&id=f1f773bc&scoped=true&"
import script from "./AnswerOptionsA.vue?vue&type=script&lang=js&"
export * from "./AnswerOptionsA.vue?vue&type=script&lang=js&"
import style0 from "./AnswerOptionsA.vue?vue&type=style&index=0&id=f1f773bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f773bc",
  null
  
)

export default component.exports